angular.module('impactx.list').factory('basketTemplateMenu', ['dataGen', '$securityManager', '$context', '$route', '$mdToast', '$mdDialog', '$q',
    function(dataGen, $securityManager, $context, $route, $mdToast, $mdDialog, $q) {
        var self = this;
        this.actionTranslations = {};
        this.deletionTranslations = {};

        this.initData = function()
        {
            self.ownTemplates = {label:"", subitems:[], showOpen: true};
            self.ownCompanyTemplates = {label:"", subitems:[], showOpen: true};
            self.companyTemplates = {label:"", subitems:[], showOpen: true};
        };

        this.clearData = function()
        {
            self.initData();
        };

        this.initData();

        this.refreshOwnCompanyTemplates = function()
        {
            if ($securityManager.isProcessAllowed("BasketTemplateMenu"))
            {
                var tempScope = {};
                dataGen.getData(tempScope, {},"/basket/menu/template/owncompany").then(function()
                {
                    self.ownCompanyTemplates.subitems = tempScope.data.subitems;
                    self.ownCompanyTemplates.label = tempScope.data.label;
                });
            }
        };
        this.refreshUserTemplates = function()
        {
            if ($securityManager.isProcessAllowed("BasketTemplateMenu"))
            {
                var tempScope = {};
                dataGen.getData(tempScope, {},"/basket/menu/template/own").then(function()
                {
                    self.ownTemplates.subitems = tempScope.data.subitems;
                    self.ownTemplates.label = tempScope.data.label;
                });
            }
        };
        this.refreshAllTemplates = function()
        {
            if ($securityManager.isProcessAllowed("BasketTemplateMenu"))
            {
                var tempScope = {};
                return dataGen.getData(tempScope, {},"/basket/menu/template/all").then(function()
                {
                    if (tempScope.data)
                    {
                        self.ownTemplates.subitems = tempScope.data.own.subitems;
                        self.ownTemplates.label = tempScope.data.own.label;

                        self.companyTemplates.subitems = tempScope.data.company.subitems;
                        self.companyTemplates.label = tempScope.data.company.label;

                        self.ownCompanyTemplates.subitems = tempScope.data.owncompany.subitems;
                        self.ownCompanyTemplates.label = tempScope.data.owncompany.label;

                        self.actionTranslations.rename = tempScope.trns.rename;
                        self.actionTranslations.delete = tempScope.trns.delete;
                        self.actionTranslations.addToBasket = tempScope.trns.addToBasket;

                        self.deletionTranslations.deletionLabel = tempScope.trns.basketDeletion;
                        self.deletionTranslations.reverButtonLabel = tempScope.trns.revert;
                    }
                });
            }
            else
            {
                self.clearData();
                return $q(function(resolve, reject) {
                    reject();
                });
            }
        };
        this.getOwnTemplates = function()
        {
            return self.ownTemplates;
        };
        this.getOwnCompanyTemplates = function()
        {
            return self.ownCompanyTemplates;
        };
        this.getCompanyTemplates = function()
        {
            return self.companyTemplates;
        };
        this.addTemplateToBasket = function(id)
        {
            return dataGen.post({}, {selected: [{id: id}]}, "/basket/addtocurrentbasket").then(function ()
            {
                self.refreshBasket();
            }, function () {
                self.refreshBasket();
            });
        };
        this.refreshBasket = function () {
            $context.refreshBasket({}, dataGen, $context);
            if ($route.current.templateUrl == "modules/basket/templates/basket.html")
            {
                $route.reload();
            }
        };
        this.deleteBasketTemplate = function (id)
        {
            var dataObj = {
                id: id,
                withNewData: false
            };
            dataGen.post({}, dataObj, "/basket/delete").then(function ()
            {
                self.showBasketDeletionToast(id);
                self.refreshAllTemplates();
                $context.refreshBasket({}, dataGen, $context);
            });
        };
        this.showBasketDeletionToast = function (id)
        {
            $mdToast.show({
                templateUrl: 'modules/basket/includes/basket-deletion-toast-template.html',
                hideDelay: 10000,
                preserveScope: true,
                position: "bottom right",
                controller: "BasketDeletionCtrl",
                controllerAs: 'basketDeletionCtrl',
                locals: {
                    id: id,
                    basketdeletionlabel: self.deletionTranslations.deletionLabel,
                    revertbuttonlabel: self.deletionTranslations.reverButtonLabel,
                    active: false,
                    withnewdata: false
                }
            }).then(function(response)
            {
                if (response != 'reverted')
                {
                }
                else
                {
                    self.refreshAllTemplates();
                    if ($route.current.templateUrl == "modules/basket/templates/basket.html")
                    {
                        $route.reload();
                    }
                }
            })
            ;
        };
        this.renameTemplate = function (id, event)
        {
            $mdDialog.show({
                controller: 'BasketChangeNameCtrl',
                controllerAs: 'basketChangeNameCtrl',
                templateUrl: 'modules/basket/templates/basketchangenamedialog.tmpl.html',
                clickOutsideToClose: true,
                targetEvent: event,
                locals: {
                    id: id
                }
            }).then(function(response) {
                self.refreshAllTemplates();
            });
        };
        return {
            clearData: this.clearData,
            refreshAllTemplates: this.refreshAllTemplates,
            refreshOwnCompanyTemplates: this.refreshOwnCompanyTemplates,
            refreshUserTemplates: this.refreshUserTemplates,
            getOwnTemplates: this.getOwnTemplates,
            getOwnCompanyTemplates: this.getOwnCompanyTemplates,
            getCompanyTemplates: this.getCompanyTemplates,
            addTemplateToBasket: this.addTemplateToBasket,
            renameTemplate: this.renameTemplate,
            actionTranslations: this.actionTranslations,
            deleteBasketTemplate: this.deleteBasketTemplate
        }
    }]);